/**
 * Class Notify global
 * @package vue-sweetalert2 ^3.0.3
 *
 * @property delete()
 * @property success()
 * @property error()
 * @property confirm()
 */

import Swal from 'sweetalert2'

const Notify = {
  delete(callback, configs, redirect = null) {
    const defaultConfig = {
      text: 'カテゴリを削除しますか？',
      icon: 'question',
      showCancelButton: true,
      cancelButtonText: 'キャンセル',
      confirmButtonText: '削除',
      confirmButtonColor: '#fc4949',
      reverseButtons: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: function (value) {
        return new Promise(function (resolve, reject) {
          const data = callback(value);

          data.then(result => {
            if (!result.errResponse && result.data.success) {
              resolve(result.data.data);
              Notify.success({title: result.data.message}).then(() => {
                if (redirect) {
                  return redirect();
                }
              })
            } else {
              reject(result.data.success)
              Notify.error({title: 'Error ' + (result.status || 500), text: result.data.message});
            }
          });
        });
      }
    };

    configs = {...defaultConfig, ...configs};
    return Swal.fire(configs)
  },
  error(configs = {}, isToast = false) {
    const defaultConfig = {
      title: 'Error 500',
      text: null,
      icon: 'error',
      allowOutsideClick: false,
      showCancelButton: false
    };
    const toastConfig = isToast ? {toast: true, position: 'top-end'} : {};

    configs = {...defaultConfig, ...toastConfig, ...configs}

    return Swal.fire(configs)
  },
  success(configs = {}, isToast = false) {
    const defaultConfig = {
      title: null,
      icon: 'success',
      timer: 2000,
      showConfirmButton: false,
      allowOutsideClick: false,
    };
    const toastConfig = isToast ? {toast: true, position: 'top-end'} : {};

    configs = {...defaultConfig, ...toastConfig, ...configs}

    return Swal.fire(configs)
  },
  confirm(options, callback) {
    const baseOptions = {
      title: 'Default title',
      showCancelButton: true,
      cancelButtonText: 'キャンセル',
      confirmButtonText: '削除',
      confirmButtonColor: '#fc4949',
      reverseButtons: true,
      icon: 'question',
      preConfirm: callback,
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
    }

    return Swal.fire({
      ...baseOptions,
      ...options
    })
  },
  notify(options) {
    return Swal.fire({
      ...options
    })
  }
}

export default Notify;
